import { render, staticRenderFns } from "./HeaderChat.vue?vue&type=template&id=29722c92&scoped=true&"
import script from "./HeaderChat.vue?vue&type=script&lang=js&"
export * from "./HeaderChat.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChat.vue?vue&type=style&index=0&id=29722c92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29722c92",
  null
  
)

export default component.exports